var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("transition", { attrs: { name: "fade" } }, [
        _c("div", { staticClass: "fh cc" }, [
          _c("div", { staticClass: "fh cc" }, [
            _c(
              "div",
              {
                staticClass: "menu-mobile",
                class: { "menu-mobile-expand": _vm.showMenu }
              },
              [
                _c(
                  "div",
                  { staticClass: "fv ct", staticStyle: { width: "100%" } },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "fv cc",
                        staticStyle: { width: "100%", "margin-top": "20px" }
                      },
                      [
                        _c("img", {
                          staticStyle: { width: "40%" },
                          attrs: { src: "/dist/logo_menu2.png" }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "fv cc",
                        staticStyle: {
                          width: "100%",
                          height: "60px",
                          color: "white",
                          "font-size": "18px",
                          "font-weight": "500"
                        }
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.nombreUsuario) +
                            "\n                   "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "fh lc",
                        staticStyle: { width: "100%", height: "30px" },
                        on: { click: _vm.cambiarPass }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "fv lc",
                            staticStyle: {
                              width: "90%",
                              height: "100%",
                              "margin-left": "20px",
                              color: "white",
                              "font-size": "10px"
                            }
                          },
                          [
                            _vm._v(
                              "\n                           Cambiar Contraseña\n                       "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "fv lc",
                            staticStyle: { width: "10%", height: "100%" }
                          },
                          [
                            _c("img", {
                              staticStyle: {
                                width: "15px",
                                height: "15px",
                                "margin-right": "10px"
                              },
                              attrs: { src: "/dist/icon_right_white.png" }
                            })
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "fh lc",
                        staticStyle: { width: "100%", height: "30px" },
                        on: { click: _vm.cerrarSesion }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "fv lc",
                            staticStyle: {
                              width: "90%",
                              height: "100%",
                              "margin-left": "20px",
                              color: "white",
                              "font-size": "10px"
                            }
                          },
                          [
                            _vm._v(
                              "\n                           Cerrar Sesion\n                       "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "fv lc",
                            staticStyle: { width: "10%", height: "100%" }
                          },
                          [
                            _c("img", {
                              staticStyle: {
                                width: "15px",
                                height: "15px",
                                "margin-right": "10px"
                              },
                              attrs: { src: "/dist/icon_right_white.png" }
                            })
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "fv cc",
                      staticStyle: {
                        width: "90%",
                        height: "1px",
                        background: "#bbbbbb",
                        "margin-top": "10px"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showSeccionCliente,
                            expression: "showSeccionCliente"
                          }
                        ],
                        staticClass: "fv lb",
                        staticStyle: {
                          width: "100%",
                          height: "40px",
                          color: "white",
                          "font-size": "18px",
                          "font-weight": "500",
                          "margin-left": "40px"
                        }
                      },
                      [
                        _vm._v(
                          "\n                       Cliente\n                   "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showSeccionCliente,
                            expression: "showSeccionCliente"
                          }
                        ],
                        staticClass: "fh lc",
                        staticStyle: { width: "100%", height: "30px" },
                        on: { click: _vm.btnCliente }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "fv lc",
                            staticStyle: {
                              width: "90%",
                              height: "100%",
                              "margin-left": "20px",
                              color: "white",
                              "font-size": "10px"
                            }
                          },
                          [
                            _vm._v(
                              "\n                           " +
                                _vm._s(_vm.nombreCliente) +
                                "\n                       "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "fv lc",
                            staticStyle: { width: "10%", height: "100%" }
                          },
                          [
                            _c("img", {
                              staticStyle: {
                                width: "15px",
                                height: "15px",
                                "margin-right": "10px"
                              },
                              attrs: { src: "/dist/icon_right_white.png" }
                            })
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showSeccionCliente,
                          expression: "showSeccionCliente"
                        }
                      ],
                      staticClass: "fv cc",
                      staticStyle: {
                        width: "90%",
                        height: "1px",
                        background: "#bbbbbb",
                        "margin-top": "10px"
                      }
                    })
                  ]
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "fh cc" }, [_c("router-view")], 1)
        ])
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fadePro" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showProgress,
                expression: "showProgress"
              }
            ],
            staticClass: "modal",
            attrs: { id: "myModal" },
            on: { click: _vm.closePopup }
          },
          [
            _c("div"),
            _vm._v(" "),
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "loader" })
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fadePopup" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.popupVisible,
                expression: "popupVisible"
              }
            ],
            attrs: { id: "myModalPopup" },
            on: { click: _vm.clickOut }
          },
          [
            _c("div", {
              staticStyle: { "z-index": "10" },
              attrs: { id: "back-popup" }
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "modal-content-mainpopup",
                staticStyle: { "z-index": "10" }
              },
              [
                _c("div", { attrs: { id: "textoContainer-mainpopup" } }, [
                  _c("p", { attrs: { id: "texto-mainpopup" } }, [
                    _vm._v(_vm._s(_vm.popupTxt))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { attrs: { id: "btnContainer-mainpopup" } }, [
                  _c(
                    "button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.popupTxtBtnCancelVisible,
                          expression: "popupTxtBtnCancelVisible"
                        }
                      ],
                      attrs: { id: "mainpopupBtn1" },
                      on: { click: _vm.btnCancel }
                    },
                    [_vm._v(_vm._s(_vm.popupTxtBtnCancel))]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      attrs: { id: "mainpopupBtn2" },
                      on: { click: _vm.btnOk }
                    },
                    [_vm._v(_vm._s(_vm.popupTxtBtnOk))]
                  )
                ])
              ]
            )
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bced26ea", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bced26ea","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-bced26ea","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app.vue
// module chunks = 0